import { render } from "./Konnpaay.vue?vue&type=template&id=98db25f8"
import script from "./Konnpaay.vue?vue&type=script&lang=js"
export * from "./Konnpaay.vue?vue&type=script&lang=js"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__